import Factura from "../facturacion/classFactura";

const factura = new Factura();

export const state = () => ({ ...factura.state });
export const getters = { ...factura.getters };
export const actions = { ...factura.actions };
export const mutations = { ...factura.mutations };
